module.exports = __webpack_public_path__ + "static/media/foto2.a5a740e0.jpg";